import { useRef } from "react";

import { BlockContent, ITellAFriendCompetition } from "@chef/feature-sanity";

import { TellAFriendCompetition } from "./TellAFriendCompetition/Competition";
import { TellAFriendOverview } from "./TellAFriendOverview";

interface TellAFriendLayoutProps {
  children: React.ReactNode;
  tellAFriendCompetition: ITellAFriendCompetition;
  competitionInformationRef: React.RefObject<HTMLDivElement>;
}

export const TellAFriendLayout = ({
  children,
  tellAFriendCompetition,
  competitionInformationRef,
}: TellAFriendLayoutProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToInvitation = () => {
    scrollRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="max-w-lg mx-auto" ref={scrollRef}>
      {children}
      {tellAFriendCompetition && (
        <TellAFriendCompetition
          scrollRef={competitionInformationRef}
          scrollToInvitation={scrollToInvitation}
          competitionBlock={
            <BlockContent
              body={tellAFriendCompetition.competitionBlock}
              prose={{ padding: "none" }}
            />
          }
          competitionSetting={tellAFriendCompetition.competitionSetting}
          howCompetitionWorks={
            <BlockContent
              body={tellAFriendCompetition.howCompetitionWorks}
              prose={{ padding: "none" }}
            />
          }
          competitionPrize={
            <BlockContent
              body={tellAFriendCompetition.competitionPrize}
              prose={{ padding: "none" }}
            />
          }
        />
      )}

      <TellAFriendOverview />
    </div>
  );
};
